import { message } from "antd";
import React, { useState } from "react";
import { Api, ApiMethod } from "../components/common/ApiLinkedButton";
import { Loader } from "../components/common/Loader.component";
import { ImageGeneratorResponse } from "../image/Image.model";
import { AssetLocation } from "../model/Picture";

interface FileUploadComponentProps {
  onImageUpload: (image: AssetLocation) => Promise<void>;
  api: string;
  required?: boolean;
}

export function FileUploadComponent(props: FileUploadComponentProps) {
  let [uploading, setUploading] = useState<boolean>();
  function onChangeHandler(event: any) {
    let file = event.target.files[0];

    var MAX_FILE_SIZE = 20 * 1024 * 1024;

    if (event.target && file.size <= MAX_FILE_SIZE) {
      const data = new FormData();
      data.append("file", file);
      setUploading(true);
      new Api<FormData, ImageGeneratorResponse>(props.api, ApiMethod.POST)
        .executeV2(data)
        .then((imageResponse) => {
          return props.onImageUpload(imageResponse.image);
        })
        .finally(() => {
          setUploading(false);
        });
    } else {
      message.error("Maximum file upload limit is 20MB.");
    }
  }

  return (
    <>
      {uploading && (
        <>
          <small>
            <Loader />
          </small>{" "}
          Uploading. Please wait...
        </>
      )}
      {!uploading && (
        <input
          type="file"
          onChange={onChangeHandler}
          className="form-control"
          required={props.required}
        />
      )}
    </>
  );
}
